import backofficeService from '@/api/backoffice.js'
// import publicService from '../../api/public'
// let cachedonor = null
// let cacheTopdonor = null
// let cacheOutstandingBalance = null

// setInterval(() => {
//   nullEverything()
// }, 3600000);

// function nullEverything() {
//   // console.log('i was nullEverything here')
//   cachedonor = null
//   cacheOutstandingBalance = null
//   cacheTopdonor = null
// }

// window.onload = function () {

//   document.addEventListener('invoiceCreated', nullEverything)
// }
// document.addEventListener('invoiceCreated', nullEverything)


export default {

  create(data) {
    return backofficeService.Api().post('donorPaymentRequest', data)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch(error => error)
  },

  async getAll(params) {
    // if (cachedonor) return cachedonor
    return backofficeService.Api().get('donorPaymentRequest', {
        params
      })
      .then(response => {
        // cachedonor = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`donorPaymentRequest/${id}`, data)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  delete(id) {
    return backofficeService.Api().delete(`donorPaymentRequest/${id}`)
      .then(response => {
        // nullEverything()
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async sendLink(id, data) {
    return backofficeService.Api().put(`donorPaymentRequest/sendLink/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}